import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateAdminConversationForm } from '@entities/AdminConversationCategory/api/handlers/updateAdminConversationForm';

export function useUpdateAdminConversationFormQuery() {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: updateAdminConversationForm,
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['adminConversationCategories'] });
        },
    });
}
